export default "__VITE_ASSET__DMzDLznY__"